import {createClient} from '@sanity/client';

export const client = createClient({
    projectId: "6aqcwp9l",
    dataset: "production",
    apiVersion: '2023-10-13'
});